import { api } from './api'

/**
 * Single switch for the Management Dashboard / CRM mock layer.
 * Flip to false once the /admin/dashboard and /admin/crm endpoints are live.
 * Shared by dashboardService.js and crmService.js.
 */
export const USE_MOCK_DATA = false

export const REPORTING_PERIODS = [
    { key: '30d', label: 'Last 30 Days' },
    { key: '3m', label: 'Last 3 Months' },
    { key: '6m', label: 'Last 6 Months' },
    { key: '12m', label: 'Last 12 Months' },
]

const m = (label, value, definition, crmFilter = null) => ({ label, value, definition, crmFilter })

function mockDashboard(period) {
    return {
        success: true,
        data: {
            period: { key: period, from: null, to: null, timezone: 'Europe/London' },
            subscriber: {
                totalOrganisations: m('Total registered organisations', 128, 'All organisations registered on the platform.', { recordType: 'organisation' }),
                activeTrials: m('Active trials', 22, 'Organisations currently in a trial.', { trialStatus: 'active' }),
                trialsEndingSoon: m('Trials ending within 7 days', 5, 'Active trials ending in the next seven days.', { endingWithin7Days: 'true' }),
                completedTrials: m('Completed trials', 40, 'Trials completed in the period.', { trialStatus: 'completed' }),
                conversionRate: m('Trial conversion rate', '38%', 'Completed trials that became paying organisations.'),
                activePaying: m('Active paying organisations', 61, 'Organisations with an active paid subscription.', { accountStatus: 'active_paid' }),
                newPaying: m('New paying organisations', 9, 'Organisations that started paying in the period.', { accountStatus: 'active_paid', period }),
                suspended: m('Suspended organisations', 4, 'Organisations currently suspended.', { suspended: 'true' }),
                reactivated: m('Reactivated organisations', 2, 'Organisations reactivated in the period.', { reactivated: 'true' }),
                netGrowth: m('Net subscriber growth', '+7', 'New paying minus lost paying organisations in the period.'),
            },
            usage: {
                registeredUsers: m('Registered users', 312, 'All registered users.', { recordType: 'user' }),
                neverLoggedIn: m('Organisations never logged in', 11, 'Organisations where no user has ever logged in.', { neverLoggedIn: 'true' }),
                activeOrganisations: m('Active organisations', 74, 'At least one user completed an authenticated session in the period.', { activeInPeriod: 'true', period }),
                completeSettings: m('Tender Settings completed', 96, 'Organisations with completed Tender Settings.', { incompleteSettings: 'false' }),
                incompleteSettings: m('Tender Settings incomplete', 32, 'Organisations with incomplete Tender Settings.', { incompleteSettings: 'true' }),
                receivingProfileMatches: m('Receiving Profile Matches', 70, 'At least one new Profile Match in the period.', { receivingProfileMatches: 'true', period }),
                receivingWiderDiscovery: m('Receiving Wider Discovery', 83, 'At least one relevant Wider Discovery opportunity in the period.', { receivingWiderDiscovery: 'true', period }),
                noMatches: m('Receiving no matches', 18, 'Zero Profile Matches and zero Wider Discovery opportunities in the period.', { noMatches: 'true', period }),
                opened: m('Opportunities opened', 1840, 'Distinct opens of the Tender Opportunity Information page (de-duplicated per session).'),
                saved: m('Opportunities saved', 420, 'Unique opportunities saved by an organisation in the period.'),
                viewDocuments: m('View Tender Documents actions', 265, 'Activations of the onward action. Does not indicate documents were accessed on the buyer system.'),
            },
            revenue: {
                mrr: m('Current MRR', 9150, 'Monthly recurring revenue, excluding VAT.'),
                arr: m('Current ARR', 109800, 'Annual recurring revenue, excluding VAT.'),
                currency: 'GBP',
            },
        },
    }
}

export const dashboardService = {
    async getDashboard(period = '30d') {
        if (USE_MOCK_DATA) return mockDashboard(period)
        return api.get(`/admin/dashboard?period=${encodeURIComponent(period)}`)
    },
}

export default dashboardService
